<template>
  <div>
    <common-manage ref="commonManage"></common-manage>
    <v-row no-gutters>
      <v-subheader><b>{{ $t('user.list.header-name') }}</b></v-subheader>
      <v-spacer></v-spacer>
      <v-btn class="blue accent-4" dark to="user-add">Add New User</v-btn>
    </v-row>
    <v-row>
      <v-col>
        <v-col cols="6"><v-text-field v-model="search" placeholder="Search Users"></v-text-field></v-col>
        <v-data-table :headers="getHeaders()" :items="Users" :search="search" class="elevation-1" dense>
          <template v-slot:[`item.index`]="{ item }">
            {{Users.indexOf(item) + 1}}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="editUser(item.id)" color="primary" small>mdi-pencil</v-icon>
              </template><span>Edit</span>
            </v-tooltip> 
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="deleteUser(item.id)" color="error" small>mdi-delete</v-icon>
              </template><span>Delete</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'
import WebService from '@/service/WebService'
export default {
  data () {
    return {
      search: '',
      Users: [],
    }
  },
  mounted () {
    this.getUsers()
  },
  methods : {
    getHeaders(){
      if(localStorage.getItem('user_type_id')==1){
        return [
          { text: '#', value: 'index' },
          { text: 'Name', value: 'name' },
          { text: 'School', value: 'school.name' },
          { text: 'User Type', value: 'user_type.name' },
          { text: 'Actions', value: 'actions' },
        ];
      } else {
        return [
          { text: '#', value: 'index' },
          { text: 'Name', value: 'name' },
          { text: 'User Type', value: 'user_type.name' },
          { text: 'Actions', value: 'actions' },
        ]
      }
    },
    getUsers () {
      this.$refs.commonManage.open(1, true)
      WebService.getCall('users').then((response) => {
        this.Users = response.data.data.data
        this.$refs.commonManage.open(1, false)
        if(response.data.data.last_page > response.data.data.current_page){
          for(let i=2; i <= response.data.data.last_page; i++){
            WebService.getCall('users?page=' + i).then((response) => {
              for(let j = 0; j < response.data.data.data.length; j++){
                this.Users.push(response.data.data.data[j])
              }
            })
          }
        }
      });
    },
    async deleteUser (params) {
      if ( await this.$refs.commonManage.confirm()){
        WebService.deleteCall('users',{user_id:params}).then((response) => {
          this.$refs.commonManage.open(1, false)
          let data = {}
          data.message = response.data.message
          data.colour = "success"
          this.$refs.commonManage.open(3, data)
        });
      }
    },
    editUser (params) { 
      this.$router.push('/user-edit/' + params)
    },
    dateFormatted (params) {
      return params ? moment(params).format('D-M-Y') : ''
    },
  },
  beforeRouteEnter (to, from, next) {
    if (localStorage.getItem('loggedIn') === 'true') {
      next()
    } else {
      next('/')
    }
  }
}
</script>